import { GlobalStylesProps, GlobalStyles as MUIGlobalStyles } from '@mui/material';
import { FC } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const layoutStyles: GlobalStylesProps['styles'] = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};

export const GlobalStyles: FC = () => (
  <MUIGlobalStyles
    styles={{
      main: layoutStyles,
    }}
  />
);
